module.exports = __webpack_public_path__ + "img/pc_board.fed8dc3.jpg";